<template>
  <teleport to="head">
    <title>{{ meta.pageTitle }}</title>
  </teleport>
</template>
<script>
import {computed} from "vue";
import { useRouter } from 'vue-router'
export default {
  setup(){
    const router = useRouter()
    const meta = computed(() => router.currentRoute.value.meta)

    return{
      meta
    }
  }
}
</script>
